import {
    ActionTypes,
    IRequestInformationAction,
    IReceiveInformationAction,
    ISetInformationApiUpdateStateStateAction
} from './Information.action-types';
import { IInformationRequest, IInformationState } from './Information.types';
export const requestInformation = (data?: IInformationRequest): IRequestInformationAction => ({
    type: ActionTypes.INFORMATION_REQUEST,
    data
});

export const receiveInformation = (
    data: IInformationState,
    success: boolean,
    errorMsg: string
): IReceiveInformationAction => {
    const type = success ? ActionTypes.INFORMATION_SUCCEEDED : ActionTypes.INFORMATION_FAILED;
    return {
        type,
        data,
        errorMsg
    };
};

export const setInformationApiUpdateState = (data: boolean): ISetInformationApiUpdateStateStateAction => ({
    type: ActionTypes.INFORMATION_SET_APIUPDATESTATE,
    data
});
